/* unplugin-vue-components disabled */import { render } from "./phoneBarTime.vue?vue&type=template&id=db490ef4&ts=true"
import script from "./phoneBarTime.vue?vue&type=script&lang=ts"
export * from "./phoneBarTime.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__